import { type DayPart } from './daypart-entry';

class WorkplacesForDayPart {
  dayPart?: DayPart;

  workplaceIds: string[] = [];
}

export default WorkplacesForDayPart;
